import {RootState} from '../rootReducer';

export const modelFileSelector = (state: RootState) => state.modelFile;

export const modelFileItemHistorySelector = (state: RootState) => state.modelFile.itemHistory;
export const modelFileItemHistorySelectorBuilder = (params: [string, string]) => (state: RootState) =>
  modelFileItemHistorySelector(state)[`${params[0]}-${params[1]}`];
